import { render, staticRenderFns } from "./CoDoorsNKeysBase.vue?vue&type=template&id=566948a5&"
import script from "./CoDoorsNKeysBase.vue?vue&type=script&lang=js&"
export * from "./CoDoorsNKeysBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports